export default __webpack_public_path__ + "static/media/revenue-source.322d4414.png";